import React, { ReactNode } from 'react'
import styled from 'styled-components'
import colors from './colors'
import { SubTitle1 } from './Typo'
// import { ReactComponent as LeftIcon } from '../images/title-left-icon.svg'

type Props = {
  title: ReactNode
}

const Title = styled.div`
  padding: 1.5rem 1rem;
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const PageTitle: React.FC<Props> = ({ title }) => {
  return (
    <Title>
      {/* <LeftIcon /> */}
      <SubTitle1 color={colors.textForTitle}>{title}</SubTitle1>
    </Title>
  )
}
